import { jsx } from "react/jsx-runtime";
import { Badge, __css, mergeClasses, tokens } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
const DISCIPLINES = [
  "architecture",
  "structure",
  "vrd",
  "fluides",
  "electricite",
  "topographie",
  "geotechnique",
  "opc"
];
const useStyles = __css({"base":{"st59p4":"f11khh7q","B7ck84d":"f1ewtqcl","Beyfa6y":0,"Bbmb7ep":0,"Btl43ni":0,"B7oj6ja":0,"Dimara":"f44lkw9","Bnt446c":0,"B1hrpyx":0,"Fjva8n":"f1ifyi5","i8kkvl":"f1ufnopg","Be2twd7":"f1ugzwwg","Bg96gwp":"f104wqfl","Bhrd7zp":"fdj6btp","Huce71":"fz5stix","g2u3we":"fghlq4f","B9xav0g":"fb073pr","ijz38e":"f1u9dzx2","Ctt3hk":"f19bg87z","Ftih45":"f1wl9k8s","Br0sdwz":"fd1hv5k","nmree":"f1s9zyos","B2zvqh9":"fnny5tc","ebugjb":"f1dzc99s","r59vdv":0,"Budzafs":0,"ck0cow":0,"n07z76":0,"Gng75u":"f1h23yni","cmx5o7":"f3e8jtw"},"architecture":{"De3pzq":"f8k7hur","sj55zd":"fqsigj7"},"structure":{"De3pzq":"fu7oh0l","sj55zd":"fdlvcco"},"vrd":{"De3pzq":"f19ut4y6","sj55zd":"f1gymlvd"},"fluides":{"De3pzq":"f6hvv1p","sj55zd":"f135dsb4"},"electricite":{"De3pzq":"f3z4w6d","sj55zd":"f9603vw"},"topographie":{"De3pzq":"ff379vm","sj55zd":"fwctg0i"},"geotechnique":{"De3pzq":"f14wu1f4","sj55zd":"ftl572b"},"opc":{"De3pzq":"f4xb6j5","sj55zd":"f1f1fwnz"}});
function DisciplineTag({ discipline, className }) {
  const { t } = useTranslation("ui");
  const styles = useStyles();
  return /* @__PURE__ */ jsx(
    Badge,
    {
      appearance: "tint",
      shape: "rounded",
      size: "large",
      className: mergeClasses(styles.base, styles[discipline], className),
      "data-discipline": discipline,
      children: t(`components.disciplines.${discipline}`)
    }
  );
}
export {
  DISCIPLINES,
  DisciplineTag
};
//# sourceMappingURL=discipline-tag.js.map

import "/opt/batiflow/app/packages/ui/dist/components/discipline-tag/discipline-tag.griffel.css";